import React from "react";
import {isViewVisible} from "../../../utils/ViewSettings";
import ErrorsView from "./components/ErrorsView";
import AppErrorsView from "./components/AppErrorsView";
import {Biscuit} from "../../../utils";
import Rbac from "../../../utils/Rbac";


export const ErrorsPage  = props => {
    let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    let indexView = Biscuit.get('user.is_superuser') === 'true'?'errors':'';
    return (
        <>
            {(_view === 'errors' || (_view === 'index' && indexView === 'errors')) &&
            <ErrorsView
                name={"errors"}
                dispatch={props.dispatch}
                params={props.params}
                returnPath={props.returnPath}
            />
            }
            {(_view === 'apperrors') &&
                <AppErrorsView
                    name={"apperrors"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                />
            }
            </>
    );
}